/**
 * AMENITIES — run-scoped perks sold between floors alongside the requisition
 * stat tracks (one total approval per interval across both shelves). Defs are
 * data: id + copy here, prices and effect parameters in tuning.amenities,
 * effect hooks at the relevant sim/game sites (search for amenity id).
 *
 * The stock starts small; RESIDUALS (a persistent balance banked as a
 * fraction of final run score) buy permanent additions to the pool.
 */
export type AmenityId = 'rupture' | 'metabolism' | 'invoice' | 'momentum' | 'lingering' | 'surcharge'

export interface AmenityDef {
  id: AmenityId
  name: string
  desc: string
}

export const AMENITY_DEFS: Record<AmenityId, AmenityDef> = {
  rupture: {
    id: 'rupture',
    name: 'RUPTURE CLAUSE',
    desc: 'destroyed hostiles burst into brief damaging shrapnel'
  },
  metabolism: {
    id: 'metabolism',
    name: 'SURPLUS METABOLISM',
    desc: 'rations beyond max vitals convert to a decaying shield'
  },
  invoice: {
    id: 'invoice',
    name: "DEAD MAN'S INVOICE",
    desc: 'losing a life refunds a fraction of the index spent this run'
  },
  momentum: {
    id: 'momentum',
    name: 'MOMENTUM RIDER',
    desc: 'kills charge OVERRIDE substantially faster'
  },
  lingering: {
    id: 'lingering',
    name: 'LINGERING SANCTION',
    desc: 'sanctioned charges leave a damaging field for a few seconds'
  },
  surcharge: {
    id: 'surcharge',
    name: 'IMPACT SURCHARGE',
    desc: 'the heavy shot cycles substantially faster'
  }
}

/** available in every run from the first install */
export const BASE_STOCK: AmenityId[] = ['rupture', 'metabolism', 'invoice']

/** unlocked permanently, in order, by investing residuals */
export const LOCKED_POOL: AmenityId[] = ['momentum', 'lingering', 'surcharge']
